export const EMPTY_LOGIN_INFO = {
  email: { value: '' },
  password: { value: '' },
};

export const EMPTY_LOGIN_INFO_VALUES = {
  email: '',
  password: '',
};

export const EXAMPLE_LOGIN_INFO = {
  email: { value: 'johndoe@example.com' },
  password: { value: 'password123' },
};

export const DEFAULT_SUBMIT_TEXT = 'Login';
